import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

export const SkeletonLoaderOverlayBox = styled(Box)`
  width: 100%;
  z-index: 7;
  border-radius: 4px;
`

export const SkeletonLoaderContainer = styled(Box)<{ padding?: string }>`
  position: relative;
  padding: ${({ padding }) => padding || 0};
`
